/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RiskTypeDto } from '../../models/risk-type-dto';

export interface GetRiskTypes$Params {
}

export function getRiskTypes(http: HttpClient, rootUrl: string, params?: GetRiskTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RiskTypeDto>>> {
  const rb = new RequestBuilder(rootUrl, getRiskTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RiskTypeDto>>;
    })
  );
}

getRiskTypes.PATH = '/risks/types';
